import { COHORT_STATUS_COMPLETED } from "@pathwright/web/src/modules/group/constants"
import get from "lodash/get"

export const getCohortCompletedMessage = (t) => {
  if (!window.App) return ""

  const resourceState = window.App.getStore("resource").getState()
  const cohort = get(resourceState, "offering")
  const permissions = get(cohort, "permissions", {})
  const { can_edit, can_facilitate, can_edit_resource } = permissions

  const isCompletedCohort = cohort && cohort.status === COHORT_STATUS_COMPLETED
  if (!isCompletedCohort) return ""

  const isStaff = can_edit || can_facilitate || can_edit_resource

  let explanation = t("This path is read-only")
  const prefix = isStaff ? `${t("Cohort completed")}: ` : ""

  if (prefix) {
    explanation = explanation.toLowerCase()
  }

  return `${prefix}${explanation}.`
}
